module.exports = __webpack_public_path__ + "static/img/ic_mart@2x.773e3a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_mart@2x.png
// module id = qMy2
// module chunks = 1